import {
  AfterContentChecked,
  Directive,
  ElementRef,
  HostBinding,
} from '@angular/core';

const expandedClass = 'mat-expanded';

@Directive({
  selector: '[zelisExpansionPanel]',
})
export class ExpansionPanelDirective implements AfterContentChecked {
  @HostBinding('class.zelis-expansion-panel') sapphireExpansionPanelClass =
    true;
  @HostBinding('class.next-sibling-expanded') get nextSiblingExpandedClass() {
    return this.nextSiblingExpanded;
  }
  @HostBinding('class.previous-sibling-expanded')
  get previousSiblingExpandedClass() {
    return this.previousSiblingExpanded;
  }
  private previousSiblingExpanded = false;
  private nextSiblingExpanded = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterContentChecked() {
    this.checkNextSibling();
    this.checkPreviousSibling();
  }

  private checkPreviousSibling() {
    this.previousSiblingExpanded =
      this.elementRef.nativeElement.previousElementSibling?.classList.contains(
        expandedClass
      ) ?? false;
  }

  private checkNextSibling() {
    this.nextSiblingExpanded =
      this.elementRef.nativeElement.nextElementSibling?.classList.contains(
        expandedClass
      ) ?? false;
  }
}
